var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8807 2.20711C15.5106 1.57714 15.0645 0.5 14.1736 0.5H1.00201C0.111101 0.5 -0.335067 1.57714 0.294898 2.20711L5.2949 7.20711C5.48244 7.39464 5.58779 7.649 5.58779 7.91421V12.5C5.58779 13.0523 6.03551 13.5 6.58779 13.5H8.58779C9.14008 13.5 9.58779 13.0523 9.58779 12.5V7.91421C9.58779 7.649 9.69315 7.39464 9.88068 7.20711L14.8807 2.20711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/filter_list.9a8e31f7ece22689e4db76b36ac5a4a1.svg";
export { ForwardRef as ReactComponent };